// auth.guard.ts
import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  // canActivate can now return a Promise<boolean>
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    console.log("[AUTH GUARD] canActivate called for route:", state.url);
    try {
      const loggedIn = await this.authService.isLoggedIn();
      console.log("[AUTH GUARD] isLoggedIn returned:", loggedIn);
      if (!loggedIn) {
        console.log("[AUTH GUARD] Not logged in, redirecting to /login");
        this.router.navigate(["/login"]);
        return false;
      }

      const requiredRoles = next.data["roles"] as string[] | undefined;
      if (requiredRoles && requiredRoles.length > 0) {
        console.log("[AUTH GUARD] Checking required roles:", requiredRoles);
        const has = await this.authService.hasRolesByName(requiredRoles);
        console.log("[AUTH GUARD] Has required roles:", has);
        if (!has) {
          console.log(
            "[AUTH GUARD] Missing required roles, redirecting to /access-denied"
          );
          this.router.navigate(["/access-denied"]);
          return false;
        }
      }

      console.log("[AUTH GUARD] Auth check passed, allowing navigation");
      return true;
    } catch (err) {
      // if anything goes wrong (e.g. token fetch fails), redirect to login
      console.error("[AUTH GUARD] Error during auth check:", err);
      this.router.navigate(["/login"]);
      return false;
    }
  }
}
